const LEDGER = {
  STAGE_INIT: 0,
  STAGE_SELECTION: 1,
  STAGE_LEDGER_INIT: 2,
  STAGE_READY: 3,
  STAGE_WAIT: 4,
  STAGE_GENERATED: 5,
  STAGE_SUBMITTED: 6,
  STAGE_CONFIRMING: 7,
  STAGE_CONFIRMED: 8,
  STAGE_ERROR: 15,
  HDPATH: [44, 118, 0, 0, 0],
};

const GENESIS_SUPPLY = 1000000000000000;
const TOTAL_GOL_GENESIS_SUPPLY = 50000000000000;

const POCKET = {
  STAGE_TWEET_ACTION_BAR: {
    ADD_AVATAR: 'addAvatar',
    FOLLOW: 'follow',
    TWEET: 'tweet',
  },
};

export { LEDGER, GENESIS_SUPPLY, TOTAL_GOL_GENESIS_SUPPLY, POCKET };
